import { Box } from "@mui/material";
import { GadgetInfoTopic } from "./GadgetInfoTopic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIdCard } from "@fortawesome/free-solid-svg-icons";
import { License } from "../../../models/GadgetModel";

interface GadgetLicenseInfoProps {
    license: License
}

export const GadgetLicenseInfo = ({license}: GadgetLicenseInfoProps) => {
    return (
        <Box p={1}>
            <GadgetInfoTopic
                header={license.description}
                icon={<FontAwesomeIcon icon={faIdCard} />}
                dataTestId={"gadget-license-info"}
            />
        </Box>
    )
}